<script>
import { formatStatusMessage } from '@utils/request'

import { appComputed, authComputed } from '@state/helpers'
import appConfig from '@src/app.config'

export default {
  page: {
    title: '登入',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  data() {
    return {
      forgotMode: false,
      loginData: {
        // email: 'admin@j-tails.com',
        // password: 'j-tails@2020',
        email: process.env.VUE_APP_BUILD_MODE === 'admin-app-build' ? '' : '',
        password: process.env.VUE_APP_BUILD_MODE === 'admin-app-build' ? '' : '',
        identity: null,
        code: '',
      },
      resetData: {
        password: '',
        passwordConfirm: '',
      },
      resetRules: {
        password: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('請輸入密碼'))
              }
              const passwordPattern = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%*#?&])|(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&])|(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&]).{8,16}/
              const passwordConfirmValue = this.resetData.passwordConfirm
              if (!passwordPattern.test(value)) {
                callback(new Error('請用 8~16 個大小寫英文字母、數字與特殊符號組合'))
              }
              if (passwordConfirmValue !== '') {
                this.$refs.form.validateField('passwordConfirm')
              }

              callback()
            },
            trigger: 'blur',
          },
        ],
        passwordConfirm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('請再次輸入密碼'))
              }
              const passwordValue = this.resetData.password
              if (value !== passwordValue) {
                callback(new Error('兩次輸入的密碼不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
      buttonLoading: false,
      subscriptionData: {},
      bindCardFormData: '',
      processingLogin: false,
      processingText: '',
      passwordVisible: false,
      superUserAlertDialog: false, // 超級管理者的登入失敗跳窗狀態
      superUserAlertList: [], // 超級管理者的登入失敗跳窗狀態
      superUserLoginId: '', // 超級管理者登入Id
      superUserLoginIndex: -1, // 超級管理者選到的index
      superUserErrorStatus: ''
    }
  },
  computed: {
    ...appComputed,
    ...authComputed,
    resetMode() {
      return this.$route.params.resetToken
    },
    formRules() {
      return {
        email: [
          {
            required: true,
            message: '請輸入 Email',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: '請輸入有效的 Email',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: !this.forgotMode,
            message: '請輸入密碼',
            trigger: 'blur',
          },
        ],
      }
    },
    superUserLoginStatus() {
      return this.superUserLoginId.length === 0
    }
  },
  created() {
    if (process.env.NODE_ENV === 'development') {
      // this.$set(this.loginData, 'email', 'admin@daydream-lab.com')  
      // this.$set(this.loginData, 'password', 'daydream5182')  
    }
  },
  methods: {
    async tryToReset() {
      this.buttonLoading = true
      try {
        await this.$store.dispatch('auth/reset', {
          ...this.resetData,
          token: this.resetMode,
        })
        await this.$alert('您的密碼已重置，請重新登入', '密碼已更新', {
          confirmButtonText: '回到登入頁',
          center: true,
        })

        this.backToLogin()
      } catch (error) {
      } finally {
        this.buttonLoading = false
      }
    },
    async tryToSendForget() {
      this.buttonLoading = true
      try {
        await this.$store.dispatch('auth/forgot', this.loginData.email)
        await this.$alert('請至您的信箱查看並進行重置密碼', '已成功寄出重置密碼信件！', {
          confirmButtonText: '確定',
          center: true,
        })
        this.switchForgotMode()
      } finally {
        this.buttonLoading = false
      }
    },
    tryToLogIn() {
      this.buttonLoading = true
      return this.$store
        .dispatch('auth/logIn', this.loginData)
        .then(() => {
          this.$set(this.loginData, 'identity', null)
          localStorage.removeItem('containerMemberId')
          this.handleLogin()
        })
        .catch((error) => {
          switch (error.status) {
            // 無綁定的卡
            case 'MERCHANT_FRONT_PLEASE_BIND_CARD_FIRST':
              this.subscriptionData = error.data.items
              this.handleBindingCard()
              break
            // 無訂閱項目
            case 'MERCHANT_FRONT_PLEASE_RENEW_SUBSCRIPTION':
              this.subscriptionData = error.data.items
              this.handleSubscription()
              break
            case 'MERCHANT_PLEASE_SELECT_IDENTITY':
              this.superUserErrorStatus = error.status
              const { data } = error
              this.superUserAlertDialog = true
              this.superUserAlertList = data['identities']
              this.superUserAlertList.forEach(item => {
                item.name = item.name ? item.name : ''
              })
              break
            default:
              this.$alert(formatStatusMessage(error.status), '登入失敗', {
                confirmButtonText: '確定',
                type: 'error',
                center: true,
              })
              break
          }
        })
        .finally(() => (this.buttonLoading = false))
    },
    async tryToBindingCard() {
      this.bindCardFormData = await this.$store.dispatch('merchant/changeCard', this.subscriptionData.merchantAlias)
      this.$nextTick(() => {
        this.$refs.cardForm.submit()
      })
    },
    async handleBindingCard() {
      await this.$confirm('設定您的付款方式後，您的會員資格就會立即開始', '您尚未設定付款方式', {
        confirmButtonText: '前往設定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
      this.$router.push({
        name: 'subscription',
      })
    },
    async handleSubscription() {
      const cardIsExpired = this.subscriptionData.creditCard.isExpired === 1
      const title = cardIsExpired
        ? '您的信用卡已過期'
        : '訂閱已到期'
      const description = cardIsExpired
        ? '請重新綁定您的信用卡'
        : '您的訂閱已到期，故無法登入。<br>欲重啟訂閱請與我們聯繫，謝謝！<br>(02)2531-6628'
      const confirmButtonText = cardIsExpired
        ? '前往更新'
        : '確定'
      await this.$confirm(description, title, {
        confirmButtonText,
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        dangerouslyUseHTMLString: true,
        // showConfirmButton:cardIsExpired,
        showCancelButton: cardIsExpired,
        showClose: cardIsExpired,
        closeOnClickModal: cardIsExpired
      })
      this.$router.push({
        name: 'logout',
      })
    },
    async handleLogin() {
      this.processingLogin = true
      this.processingText = '登入成功，取得身份權限中'
      localStorage.setItem('isReloaded', 'false');
      try {
        const userRoutes = await this.$store.dispatch('auth/fetchAccess')
        this.$router.addRoutes(userRoutes)
        await this.$store.dispatch('auth/fetchTour')
        if (this.$route.params.routeFromPath) {
          this.$router.push({
            path: String(this.$route.params.routeFromPath),
          })
        } else {
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: this.currentUser.redirect,
            }
          )
        }
      } catch (error) {
        this.processingLogin = false
      }
    },
    handleSubmitForm() {
      this.forgotMode
        ? this.tryToSendForget()
        : this.tryToLogIn()
    },
    switchForgotMode() {
      this.$refs.form.clearValidate()
      this.forgotMode = !this.forgotMode
    },
    backToLogin() {
      this.$router.push({ name: 'login' })
    },
    /**
     * @description 點選任一列表得到的資訊
     */
    selectOtherLogin(index) {
      this.superUserLoginIndex = index
      this.superUserLoginId = this.superUserAlertList[index].id
    },
    /**
     * @description MERCHANT_PLEASE_SELECT_IDENTITY 的辨識
     */
    async loginAgain() {
      this.$set(this.loginData, 'identity', this.superUserLoginId)
      await this.tryToLogIn()
      this.superUserAlertDialog = false
      this.loginData.identity = null
    }
  },
}
</script>

<template>
  <el-container class="login-container" :class="[$style.loginWrapper, { isReset: resetMode || forgotMode }]">
    <div class="loginBox">
      <div :class="[$style.top, { 'd-md-none d-block': !resetMode && !forgotMode }]">
        <template v-if="$appType() === 'ipetbooking'">
          <img :src="require(`@assets/images/logo-dark.svg`)" class="logo-pet" />
          <img :src="require(`@assets/images/login_logo.svg`)" class="logo-site" />
        </template>
        <template v-if="$appType() === 'dingbeauty'">
          <img :src="require(`@assets/images/dingBeauty-logo.svg`)" class="logo-pet" />
        </template>
      </div>
      <div class="loginBoxInner">
        <div class="leftImgBox">
          <div class="leftImgBoxInner">
            <template v-if="$appType() === 'ipetbooking'">
              <img :src="require(`@assets/images/logo-dark.svg`)" class="logo-pet" />
              <img :src="require(`@assets/images/login_logo.svg`)" class="logo-site mt-1" />
            </template>
            <template v-if="$appType() === 'dingbeauty'">
              <img :src="require(`@assets/images/dingBeauty-logo.svg`)" class="logo-ding" />
            </template>
          </div>
        </div>
        <div class="inner" :class="{ 'justify-content-center': processingLogin }">
          <transition name="login-form" appear>
            <el-form v-if="resetMode" ref="form" :model="resetData" :rules="resetRules" :class="$style.main"
              class="el-form-item--normal-margin isStyleLoginForm" @submit.native.prevent="tryToReset">
              <h3 class="fw-regular">重置密碼</h3>
              <el-form-item prop="password">
                <el-input v-model="resetData.password" :type="passwordVisible ? 'text' : 'password'" placeholder="輸入新的密碼">
                  <el-button slot="suffix" type="text" @click="passwordVisible = !passwordVisible">
                    <BaseIcon :name="passwordVisible ? 'eye-slash' : 'eye'" />
                  </el-button>
                </el-input>
              </el-form-item>
              <el-form-item prop="passwordConfirm">
                <el-input v-model="resetData.passwordConfirm" :type="passwordVisible ? 'text' : 'password'"
                  placeholder="再次輸入密碼以確認">
                  <el-button slot="suffix" type="text" @click="passwordVisible = !passwordVisible">
                    <BaseIcon :name="passwordVisible ? 'eye-slash' : 'eye'" />
                  </el-button>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="large" type="primary" class="is-fullwidth is-round" native-type="submit"
                  :loading="buttonLoading" :disabled="buttonLoading">變更密碼
                </el-button>
              </el-form-item>
              <el-button type="text" class="isPrimary" @click="backToLogin">回到登入頁</el-button>
            </el-form>
          </transition>
          <transition name="login-form" appear>
            <el-form v-if="!$route.params.resetToken" ref="form" v-loading="processingLogin" :model="loginData"
              :rules="formRules" :validate-on-rule-change="false" :class="[$style.main]"
              class="el-form-item--normal-margin isStyleLoginForm" :element-loading-text="processingText"
              @submit.native.prevent="handleSubmitForm">
              <template v-if="!processingLogin">
                <div v-if="forgotMode" :class="$style.main__header">
                  <h3 class="fw-regular">忘記密碼？</h3>
                  <p style="line-height: 1.8">不用擔心！您只要輸入您註冊的 Email，我們將會協助您重置密碼。</p>
                </div>

                <el-form-item prop="email" :class="{ 'mb-2': forgotMode }">
                  <h3 v-show="!forgotMode" class="fw-regular" style="margin-top: 0">登入</h3>
                  <el-input v-model="loginData.email" class="is-round" type="text" placeholder="Email"></el-input>
                </el-form-item>

                <template v-if="forgotMode">
                  <div :class="$style['help-text']" class="mb-3">
                    記得您的密碼？試著
                    <el-button type="text" class="isPrimary" @click="switchForgotMode">登入</el-button>
                    吧！
                  </div>
                  <el-form-item>
                    <el-button size="large" type="primary" class="is-fullwidth is-round" native-type="submit"
                      :loading="buttonLoading" :disabled="buttonLoading">取得重置密碼信
                    </el-button>
                  </el-form-item>
                </template>
                <div v-show="!forgotMode">
                  <el-form-item prop="password">
                    <el-input v-model="loginData.password" class="is-round" :type="passwordVisible ? 'text' : 'password'"
                      placeholder="密碼">
                      <el-button slot="suffix" type="text" @click="passwordVisible = !passwordVisible">
                        <BaseIcon :name="passwordVisible ? 'eye-slash' : 'eye'" />
                      </el-button>
                    </el-input>
                  </el-form-item>
                  <el-button type="text" class="is-fullwidth"
                    style="text-align: right; margin-top: -20px; margin-bottom: 20px" @click="switchForgotMode">
                    <i class="far fa-key text-primary"></i>
                    忘記密碼？
                  </el-button>
                  <el-form-item>
                    <el-button size="large" type="primary" native-type="submit" :loading="buttonLoading"
                      :disabled="buttonLoading" class="is-fullwidth is-round">登入
                    </el-button>
                  </el-form-item>
                </div>
              </template>
            </el-form>
          </transition>
        </div>
      </div>
    </div>
    <div :class="$style.footer">{{ `版本 ${appVersion}` }}</div>
    <form v-if="bindCardFormData" ref="cardForm" :action="bindCardFormData.PostUrl" method="POST" hidden>
      <input v-for="(value, field) in bindCardFormData" :key="field" :name="field" :value="value" />
    </form>
    <el-dialog :title="`錯誤編號：${superUserErrorStatus}`" :visible.sync="superUserAlertDialog" top="0" append-to-body>
      <el-card class="box-card" :class="$style.loginCard" v-if="superUserAlertList.length > 0">
        <div slot="header" class="clearfix">
          <span><u>請另外選擇登入方法</u></span>
        </div>
        <div v-for="item, index in superUserAlertList" :key="index" :class="{
          [$style['loginCard__selectDiv']]: index === superUserLoginIndex,
          [$style['loginCard__lightColor']]: !item.subscriptionState,

        }" @click="selectOtherLogin(index)">
          {{ item.alias }}&nbsp{{ `( ${item.name} )` }}
        </div>
      </el-card>
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="24" style="margin-bottom: 10px;">
          <el-input v-model="loginData.code" />
        </el-col>
        <el-col :span="24">
          <el-button :disabled="superUserLoginStatus" type="primary" class="is-round is-fullwidth"
            @click="loginAgain">確定</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- <div :class="$style['bg-mark']" :style="`background-image: url(${require('@assets/images/login_bg-pattern.svg')});`"></div> -->
  </el-container>
</template>

<style lang="scss" module>
@import '@design';

:global {

  .login-form-enter-active,
  .login-form-leave-active {
    transition: opacity 1s ease-in-out;
  }

  .login-form-enter,
  .login-form-leave-to {
    opacity: 0;
  }
}

.loginWrapper {
  // background-image: url('@assets/images/login_bg.svg');
  // background-repeat: no-repeat;
  // background-color: $color-body-bg;
  // background-position: 5% 67%;
  // @include pad {
  //   background-image: none;
  // }

  &:global {
    &.isReset {
      background-image: none;
      justify-content: center;
      padding-right: 0;

      .loginBox {
        flex-direction: column;
      }

      .loginBoxInner {
        max-width: 460px;
        width: 90%;
      }

      .leftImgBox {
        display: none;
      }

      .inner {
        width: 100%;
        justify-content: center;
        min-height: 250px;
        padding-bottom: 0;
      }

      .logo-pet {
        display: inline-block;
        height: 75px;
        margin-right: 5px;
      }


      .logo-site {
        height: 76px;
      }

      .isStyleLoginForm {
        padding: 0;
      }

      // color: #f63;
    }

    .leftLogo {}
  }
}

.top {
  margin-bottom: 25px;
  color: white;
  text-align: center;
  letter-spacing: $font-letter-spacing-base;

  // width: 145px;
  &__header {
    font-size: 2.25rem;
    font-weight: $heading-font-weight;
    line-height: 2.25rem * 1.5;
  }

  :global {
    .logo-pet {
      display: block;
      margin: 0 auto;
      width: 74px;

      @include max-md {
        width: 54px;
      }
    }

    .logo-site {}

    @include max-md {
      width: 128px;
    }

  }
}

.loginCard {
  &__selectDiv {
    color: $color-primary !important;
  }

  &__lightColor {
    opacity: 0.25;
  }

  :global {
    .el-card__header span {
      font-size: 18px;
      margin-left: 10px;
    }

    .el-card__body {
      div {
        color: $color-text-light;
        padding: 5px;
        margin: 5px;
        font-size: 16px;

        &:hover {
          color: $color-secondary;
          cursor: pointer;
        }
      }
    }
  }
}

.leftLogo {}

.main {

  // width: 486px;
  // max-width: 100%;

  padding-left: 39px;
  // margin: 0 auto;
  text-align: center;
  background-color: white;
  // box-shadow: 0px 0px 20px #00000029;
  border-radius: 8px;
  z-index: 3;

  &__header {
    margin-bottom: 25px;
  }

  @include max-md {
    padding-left: 0;
  }

  @include pad {
    width: 100%;
    margin: 0;
    box-shadow: none;
    background: transparent;
    padding-top: 0;
  }

  :global {
    .el-input-group__append {
      background: transparent;
      border-left: none;
    }

    @include pad {
      .el-input__inner {
        background: white;
      }
    }
  }
}

.help-text {
  color: $color-text;
}

.footer {
  position: absolute;
  bottom: 20px;
  left: 50%;
  // color: white;
  color: $color-secondary;
  text-transform: uppercase;
  letter-spacing: 0.15rem;
  transform: translateX(-50%);

  @include pad {
    display: none;
  }
}

.bg-mark {
  position: absolute;
  right: 64px;
  bottom: 0;
  width: 440px;
  height: 357px;
  opacity: 0.1;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @include pad {
    display: none;
  }
}
</style>
